import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityComercializacionesAddFailure,
  entityComercializacionesAddRequest,
  entityComercializacionesAddSuccess,
  entityComercializacionesLoadFailure,
  entityComercializacionesLoadRequest,
  entityComercializacionesLoadSuccess
} from './comercializaciones.actions';
import { ComercializacionesService } from './comercializaciones.service';

@Injectable()
export class ComercializacionesEffects {
  // load
  loadRequestComercializaciones = createEffect(() =>
    this.actions$.pipe(
      ofType(entityComercializacionesLoadRequest),
      mergeMap(() =>
        this.comercializacionesService.getComercializaciones().pipe(
          map((items) => entityComercializacionesLoadSuccess({ items })),
          catchError((error) => of(entityComercializacionesLoadFailure({ error })))
        )
      )
    )
  );

  // add
  addRequestComercializacion = createEffect(() =>
    this.actions$.pipe(
      ofType(entityComercializacionesAddRequest),
      switchMap((action) =>
        this.comercializacionesService.addComercializaciones(action.item).pipe(
          map((item) => entityComercializacionesAddSuccess({ item: item.comercializaciones })),
          catchError((error) => of(entityComercializacionesAddFailure({ error })))
        )
      )
    )
  );

  addSuccessComercializacion = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityComercializacionesAddSuccess)
        //tap(() => this.router.navigate(['']))
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private comercializacionesService: ComercializacionesService    
  ) {
    this.comercializacionesService.url = environment.apiUrl;
  }
}
